"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsClient = void 0;

var _interfaces = require("./interfaces");

var _data_transfer = require("./data_transfer");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ANALYTICS_TRACK_REQUEST = "AnalyticsTrackRequest";

var AnalyticsClient =
/*#__PURE__*/
function () {
  function AnalyticsClient(context, localStore) {
    var batchMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var timeIntervalMax = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;

    _classCallCheck(this, AnalyticsClient);

    this.localStore = localStore;
    this.batchMax = batchMax;
    this.timeIntervalMax = timeIntervalMax;
    this.dataSender = new _data_transfer.DataSender(context);

    if (this.localStore) {
      var previousSession = this.localStore.getItem(ANALYTICS_TRACK_REQUEST);

      if (previousSession) {
        this.workingRequest = JSON.parse(previousSession);
        this.pushData();
      }
    }
  } // track Event


  _createClass(AnalyticsClient, [{
    key: "event",
    value: function event(action, customDimensions) {
      this.t({
        e: action,
        cd: customDimensions
      });
    } // track Product Impression

  }, {
    key: "productImpression",
    value: function productImpression(action, customDimensions) {
      this.t({
        pi: action,
        cd: customDimensions
      });
    } // track User Timing

  }, {
    key: "userTiming",
    value: function userTiming(action, customDimensions) {
      this.t({
        ut: action,
        cd: customDimensions
      });
    } // track Screen View

  }, {
    key: "screenView",
    value: function screenView(action, customDimensions) {
      this.t({
        sv: action,
        cd: customDimensions
      });
    } // track page view

  }, {
    key: "pageView",
    value: function pageView(action, customDimensions) {
      this.t({
        pv: action,
        cd: customDimensions
      });
    } // track with aggregation

  }, {
    key: "t",
    value: function t(request) {
      var _this = this;

      var payload = request;

      if (!this.workingRequest) {
        this.workingRequest = new _interfaces.TrackRequest();
        this.workingRequest.tb = Date.now();
        this.workingRequest.d = [];
        setTimeout(function (num) {
          // still haven't sent working Request when timeout, then send
          // could have gotten sent by batch reaching max.
          if (_this.workingRequest && _this.workingRequest.tb === num) {
            _this.pushData();
          }
        }, this.timeIntervalMax, this.workingRequest.tb);
      }

      payload.td = Date.now() - this.workingRequest.tb;
      this.workingRequest.d.push(payload);

      if (this.localStore) {
        this.localStore.setItem(ANALYTICS_TRACK_REQUEST, JSON.stringify(this.workingRequest));
      }

      if (this.workingRequest.d.length >= this.batchMax) {
        this.pushData();
      }
    }
  }, {
    key: "pushData",
    value: function pushData() {
      this.dataSender.sendData(this.workingRequest);
      this.workingRequest = null;
    }
  }]);

  return AnalyticsClient;
}();

exports.AnalyticsClient = AnalyticsClient;